// Based on https://codepen.io/knoland/pen/XKxAJb

var THREE = require('three');
var Signal = require('signals');

import * as dat from 'dat.gui';
import { TweenMax } from 'gsap';

var Boat = function() {

    var camera, scene;
    var group, groupWheel;

    var count = 0;
    var mousePcent = 0;
    var windowW, windowH;

    var signal = new Signal.Signal();

    var create = function(_scene, _camera) {
      console.log('Boat create()');

      camera = _camera;
      scene = _scene;

      // var axis = new THREE.AxesHelper(100);
      // scene.add (axis);

      var bSmallScreen = window.innerWidth < 1024;

      // MAIN GROUP
      group = new THREE.Group();

      // Boat
      var gBoat = new THREE.PlaneBufferGeometry(18, 18);

      var mBoat = new THREE.MeshBasicMaterial( {
          map: new THREE.TextureLoader().load( bSmallScreen ? `models/boat-1024.png` : `models/boat.png` )
          ,transparent: true
      } );

      var boat = new THREE.Mesh(gBoat, mBoat);
      boat.position.y = 6;
      boat.position.z = -2;

      var nWheelWidth = 6;

      var gWheelBack = new THREE.PlaneBufferGeometry(nWheelWidth, nWheelWidth);
      var mWheelBack = new THREE.MeshBasicMaterial( {
          map: new THREE.TextureLoader().load( bSmallScreen ? 'models/wheel_back-512.png' : 'models/wheel_back.png' )
          ,transparent: true
      } );
      var wheelBack = new THREE.Mesh(gWheelBack, mWheelBack);


      // WHEEL GROUP
      groupWheel = new THREE.Group();
      groupWheel.position.z = 0.15;

      var gWheelBarre = new THREE.PlaneBufferGeometry(nWheelWidth, nWheelWidth);
      var mWheelBarre = new THREE.MeshBasicMaterial( {
          map: new THREE.TextureLoader().load( bSmallScreen ? 'models/wheel_barre-512.png' : 'models/wheel_barre.png' )
          ,transparent: true
      } );
      var wheelBarre = new THREE.Mesh(gWheelBarre, mWheelBarre);


      var gWheelCercle = new THREE.PlaneBufferGeometry(nWheelWidth, nWheelWidth);
      var mWheelCercle = new THREE.MeshBasicMaterial( {
          map: new THREE.TextureLoader().load( bSmallScreen ? 'models/wheel_cercle-512.png' : 'models/wheel_cercle.png' )
          ,transparent: true
      } );
      var wheelCercle = new THREE.Mesh(gWheelCercle, mWheelCercle);
      wheelCercle.position.z = 0.18;


      var gWheelRivet = new THREE.PlaneBufferGeometry(nWheelWidth, nWheelWidth);
      var mWheelRivet = new THREE.MeshBasicMaterial( {
          map: new THREE.TextureLoader().load( bSmallScreen ? 'models/wheel_rivet-512.png' : 'models/wheel_rivet.png' )
          ,transparent: true
      } );
      var wheelRivet = new THREE.Mesh(gWheelRivet, mWheelRivet);
      wheelRivet.position.z = 0.2;

      groupWheel.add(wheelBarre);
      groupWheel.add(wheelRivet);

      group.add(wheelCercle);
      group.add(wheelBack);
      group.add(groupWheel);
      group.add(boat);

      scene.add(group);

      groupWheel.position.y = wheelBack.position.y = wheelCercle.position.y = -1.2;

      var windowHRef = 969
      var zRef = 975
      // var windowHRef = 1080 //
      // zRef = 979
      // var windowHRef = 900 //
      // zRef = 974
      // var windowHRef = 768 //
      // zRef = 973
      // var windowHRef = 640 //
      // zRef = 949
      var windowHRef = 360 //
      zRef = 930

      // var a = 969 - 640
      // var b = a / 1.17 // ((975 - 949) / (969 - 640)) = 1.17
      // var c = b / 100

      // zRef = 975 - (((969 - window.innerHeight) / 1.17) / 100)

      var zBasedOnHeight = zRef * window.innerHeight / windowHRef

      group.position.x = 0;
      group.position.y = -3.9;
      group.position.z = zRef;

      resize();
      /*
      // Plane fit to screen
      var cameraZ = camera.position.z;
      var planeZ = 970;
      var distance = cameraZ - planeZ;
      var aspect = window.innerWidth / window.innerHeight;
      var vFov = camera.fov * Math.PI / 180;
      var planeHeightAtDistance = 2 * Math.tan(vFov / 2) * distance;
      var planeWidthAtDistance = planeHeightAtDistance * aspect;
      */

      // height = f(depth) = 2 * tan( vFOV / 2 ) * depth
      // depth = g(height) = height / ( 2 * tan( vFOV / 2 ) )

    //  https://discourse.threejs.org/t/solved-how-do-we-size-something-using-screen-pixels/1177

      // initGUI();
    }

    /**
     * TODO: Find the equation instead of hard breakpoints
     */
    const getZFromBreakpoints = () => {
      // var windowHRef = 969
      // var zRef = 975
      // var windowHRef = 1080 //
      // zRef = 979
      // var windowHRef = 900 //
      // zRef = 974
      // var windowHRef = 768 //
      // zRef = 973
      // var windowHRef = 640 //
      // zRef = 949
      // var windowHRef = 360 //
      // zRef = 930

      if (windowH < 361) return 950
      else if (windowH < 376) return 950
      else if (windowH < 641) return 968
      else if (windowH < 769) return 973
      else if (windowH < 900) return 974
      else if (windowH <= 1080) return 979
      else if (windowH <= 1440 ) return 986
      else if (windowH <= 1600 ) return 988
      else return 990
    }

    const getZtoFitDesiredWidth = (w, camera) => {
      // vertical fov in radians
      const vFOV = camera.fov * Math.PI / 180;
      // const h = 2 * Math.tan( vFOV / 2 ) * Math.abs( depth );
      // h / (2 * Math.tan( vFOV / 2 )) = Math.abs( depth );
      const z = w / (2 * Math.tan( vFOV / 2 ))
      // Math.abs to ensure the result is always positive
      return z
    }

    const resize = function() {
      windowW = window.innerWidth
      windowH = document.documentElement.clientHeight; //window.innerHeight
      const _z = getZFromBreakpoints();
      group.position.z = _z
      signal.dispatch('boatZ', _z);
    }

    var render = function() {
      group.position.y =
        -3.9
        + 0.15 * Math.sin(count * 0.02); // Up and down
        + Math.sin(-group.rotation.z / Math.PI) * windowW // Decal y when rotation z
      count++;
    }

    function setWheelOrientation(pcent) {
      mousePcent = pcent;
      // groupWheel.rotation.z = -pcent * Math.PI;
      TweenMax.to(groupWheel.rotation, 0.1, { z: -pcent * 0.5 * Math.PI })
      // group.rotation.y = -pcent * 0.005 * Math.PI;
      group.rotation.z = -pcent * 0.005 * Math.PI;
    }

    function initGUI() {
      // dat gui
      var gui = new dat.GUI();

      // var ambiantwheelDirectionGUI = wheelDirectionGUI.addFolder("ambiant");
      // ambiantwheelDirectionGUI.addColor(ambiantLightConfig, 'color').onChange(()=>{
          //     ambientLight.color = new THREE.Color( ambiantLightConfig.color );
          // });

      var wheelDirectionGUI = gui.addFolder("BOAT");
      wheelDirectionGUI.add(group.position, 'x');
      wheelDirectionGUI.add(group.position, 'y');
      wheelDirectionGUI.add(group.position, 'z');
      wheelDirectionGUI.open();
    }

    return {
      create,
      render,
      resize,
      setWheelOrientation,
      signal
    }
}
export {Boat as default};
